import { type Command } from '@patsnap/tahiti-core';
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { WireFrameExtractDialogOptions, WireFrameExtractDialogResult } from '../types';
import { WireFrameExtractDialogService } from '../wire-frame-extract-dialog-service';

export const WIRE_FRAME_EXTRACT_COMMAND = 'wireFrameExtract:open-dialog';

@injectable()
export class WireFrameExtractCommand implements Command {
    readonly id = WIRE_FRAME_EXTRACT_COMMAND;
    readonly label = 'Wire Frame Extract';

    constructor(
        @inject(WireFrameExtractDialogService)
        private readonly _wireFrameExtractDialogService: WireFrameExtractDialogService,
    ) {}

    async execute(payload: WireFrameExtractDialogOptions): Promise<WireFrameExtractDialogResult | undefined> {
        return this._wireFrameExtractDialogService.open(payload);
    }
}
